module.exports = __webpack_public_path__ + "img/page3.dd6ac3c1.png";